import { useEffect } from "react";

import { useResult } from "2g-grid";

import { DATA } from "b2b/api/paths";
import { STAV } from "b2b/constants/zadosti";

import { useColumns } from "./columns";

export default function useZadostiOdsouhlaseneTable({
  datumDo,
  datumOd,
  zdroj
}) {
  const columns = useColumns();
  const postData = {
    datumDo: datumDo.getTime(),
    datumOd: datumOd.getTime(),
    stav: STAV.POTVRZENY,
    zdroj
  };
  const grid = useResult({
    columns,
    method: "post",
    moduleKey: "zadostiOdsouhlaseneSearch",
    postData,
    resolveRequest: request => {
      delete request.columns;
      return request;
    },
    url: DATA.dataZadostiSeznam()
  });
  useEffect(() => {
    grid.load();
  }, [zdroj]);
  return grid;
}
